import http from "./httpService";

const API_PATH = '/api/ctms/1.0.0';

export const getAccomplishments = async ({serviceURL, accessToken, params}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/mytraining/accomplishments`, { headers, params });

    return data;
};

export const downloadCertificate = async ({serviceURL, accessToken, accomplishmentId}) => {
    const url = `${serviceURL}${API_PATH}/mytraining/accomplishments/${accomplishmentId}/download`;
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(url, { headers, responseType: 'blob' });

    return data;
};

export const getEnrolments = async ({serviceURL, accessToken, params}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/mytraining/enrolments`, { headers, params });

    return data;
};

export const addEnrolment = async ({serviceURL, accessToken, id}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.post(`${serviceURL}${API_PATH}/mytraining/enrolments`, { courseId: id }, { headers });

    return data;
};

export const updateEnrolment = async ({serviceURL, accessToken, id, params}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.put(`${serviceURL}${API_PATH}/mytraining/enrolments/${id}`, params, { headers });

    return data;
};

export const deleteEnrolment = async ({serviceURL, accessToken, id}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.delete(`${serviceURL}${API_PATH}/mytraining/enrolments/${id}`, { headers });

    return data;
};

export const getCourses = async ({serviceURL, accessToken, params}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/courses`, { headers, params });

    return data;
};

export const getCourseDetails = async ({id, serviceURL, accessToken}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/courses/${id}`, { headers });

    return data;
};

export const downloadAsset = async ({id, serviceURL, accessToken}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/assets/${id}/download`, { headers, responseType: 'blob' });

    return data;
};

export const getLibrary = async ({serviceURL, accessToken}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/library`, { headers });

    return data;
};

export const getCategoryDetails = async ({id, serviceURL, accessToken}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/categories/${id}`, { headers });

    return data;
};

export const getCategoryCourses = async ({id, serviceURL, accessToken, params}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/categories/${id}/courses`, { headers, params });

    return data;
};

export const updateModuleEnrolment = async ({serviceURL, accessToken, id, params}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.put(`${serviceURL}${API_PATH}/mytraining/modules/${id}/activity`, params, { headers });

    return data;
};

export const retakeModule = async ({serviceURL, accessToken, id, params}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.post(`${serviceURL}${API_PATH}/mytraining/modules/${id}/retake`, params, { headers });

    return data;
};

export const getLaunchURL = async ({id, serviceURL, accessToken, moduleId}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/mytraining/modules/${moduleId}/getlaunchurl`, { headers });

    return data;
};

export const getEvents = async ({serviceURL, accessToken, params}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/events`, { headers, params });

    return data;
};

export const getEvent = async ({serviceURL, accessToken, id}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/events/${id}`, { headers });

    return data;
};

export const getEventAttendances = async ({serviceURL, accessToken, params}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/mytraining/attendances`, { headers, params });

    return data;
};

export const bookEvent = async ({serviceURL, accessToken, eventId, moduleId}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.post(`${serviceURL}${API_PATH}/mytraining/attendances`, { eventId, moduleId }, { headers });

    return data;
};

export const updateEventBooking = async ({serviceURL, accessToken, id, params}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.put(`${serviceURL}${API_PATH}/mytraining/attendances/${id}`, params, { headers });

    return data;
};

export const deleteEventBooking = async ({serviceURL, accessToken, attendanceId}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.delete(`${serviceURL}${API_PATH}/mytraining/attendances/${attendanceId}`, { headers });

    return data;
};


const tmsService = {
    getAccomplishments,
    downloadCertificate,
    getEnrolments,
    addEnrolment,
    updateEnrolment,
    deleteEnrolment,
    getCourses,
    getCourseDetails,
    downloadAsset,
    getLibrary,
    getCategoryDetails,
    getCategoryCourses,
    updateModuleEnrolment,
    retakeModule,
    getLaunchURL,
    getEvents,
    getEvent,
    getEventAttendances,
    bookEvent,
    updateEventBooking,
    deleteEventBooking
};

export default tmsService;
